<script lang="ts">
	import { CopyButton } from "misc-ui"
	import { openDeviceImageCaptureOverlay } from "../../reusable/overlays/device-image-capture"
	import { Device, SpotlightManager } from "luxedo-data"
	import { type NewDeviceInputs, TestStation } from "./TestStationController"
	import { Toast } from "toaster"
	import { closeOverlay, openConfirmOverlay, openOverlay } from "overlay"
	import TestStationNewDeviceInputs from "./TestStation_NewDeviceInputs.svelte"

	let activeDevice: Device

	let id = $state(0)
	let pass = $state("")

	let spotlightManager: SpotlightManager
	let spotlightActive = $derived(spotlightManager?.isActive ?? false)

	TestStation.subscribe((ctx) => {
		activeDevice = ctx.activeDevice
		id = ctx.newID ?? activeDevice?.id
		pass = ctx.newPass ?? activeDevice?.password

		spotlightManager = new SpotlightManager(activeDevice)
	})

	function captureImage() {
		openDeviceImageCaptureOverlay(activeDevice)
	}

	function verifyAssign() {
		if (activeDevice.id !== 4) {
			openConfirmOverlay({
				prompt: "This device has already been assigned a new ID, would you like to re-assign?",
				buttons: {
					confirm: {
						text: "Yes",
						onClick: assign,
					},
					deny: {
						text: "Cancel",
						onClick: closeOverlay,
					},
				},
			})
		} else return assign()
	}

	async function promptDeviceInputs(): Promise<NewDeviceInputs> {
		return new Promise((res) => {
			const overlayId = openOverlay(TestStationNewDeviceInputs, {
				props: {
					onsubmit: (inputs) => {
						closeOverlay(overlayId)
						res(inputs)
					},
				},
			})
		})
	}

	async function assign() {
		// get ID / PASSWORD or AUTOGEN and LICENSE
		const inputs = await promptDeviceInputs()

		Toast.text("Assigning new ID and password...")
		await TestStation.assignAndConnect(inputs)
		Toast.success("Device setup successful!")
	}

	let isTogglingSpotlight = $state(false)
	async function toggleSpotlight() {
		isTogglingSpotlight = true
		await spotlightManager.toggle()
		isTogglingSpotlight = false
	}
</script>

<table>
	<tbody>
		<tr>
			<td> ID:</td>
			<td>{id}</td>
			<td>
				<CopyButton textContent={id} />
			</td>
		</tr>
		<tr>
			<td> Password:</td>
			<td>{pass} </td>
			<td><CopyButton textContent={pass} /></td>
		</tr>
		<tr>
			<td id="assign-row" colspan="3">
				<button onclick={verifyAssign} id="assign-button">Assign New ID and Password </button>
			</td>
		</tr>
		<tr>
			<td>
				<button onclick={captureImage} id="capture-button">Capture Images</button>
			</td>
			<td>
				<button id="print-button" onclick={toggleSpotlight} disabled={isTogglingSpotlight}>
					{#if isTogglingSpotlight}
						Toggling Spotlight....
					{:else}
						{spotlightActive ? "Deactivate" : "Activate"} Spotlight
					{/if}
				</button>
			</td>
			<td>
				<a href="/admin/print-preview?id={id}&password={pass}" target="_blank">
					<button id="print-button">Print ID and Password</button>
				</a>
			</td>
		</tr>
	</tbody>
</table>

<style>
	table {
		width: fit-content;
	}

	td {
		padding: 0.25rem;
		vertical-align: middle;
	}

	td:nth-of-type(1) {
		font-size: var(--text-small);
	}

	td:nth-of-type(2) {
		text-align: center;
	}

	td :global(.copy-button) {
		margin-left: auto;
		margin-right: 0;
	}

	td :global(.copy-button svg) {
		height: 1.5rem;
	}

	button {
		font-size: var(--text-small);
		text-align: center;
	}

	#assign-button {
		background-color: var(--ct-green);
		width: 100%;
	}
</style>
